import cx from "classnames"
import * as React from "react"
import { Link } from "gatsby"
import ArrowIcon from "../images/svg/arrow.svg"
import SolutionIcon from "../images/svg/solution.svg"
import SliderControls from "./sliderControls"

export const cases = [
  {
    title: "Lead scoring",
    link: "/solutions/lead-scoring",
    color: "bg-blue-300 hover:bg-blue-400",
    tags: ["your-customer"],
  },
  {
    title: "Retention",
    link: "/solutions/retention",
    color: "bg-red-200 hover:bg-red-300",
    tags: ["your-customer"],
  },
  {
    title: "Lifetime value",
    link: "/solutions/ltv",
    color: "bg-yellow-100 hover:bg-yellow-200",
    tags: ["your-customer"],
  },
  {
    title: "Feedback",
    link: "/solutions/feedback",
    color: "bg-red-200 hover:bg-red-300",
    tags: ["your-customer"],
  },
  {
    title: "Segmentation",
    link: "/solutions/segmentation",
    color: "bg-blue-300 hover:bg-blue-400",
    tags: ["your-customer"],
  },
  {
    title: "Product Reviews",
    link: "/solutions/product-reviews",
    color: "bg-purple-300 hover:bg-purple-400",
    tags: ["your-product"],
  },
  {
    title: "A/B testing",
    link: "/solutions/ab-testing",
    color: "bg-purple-200 hover:bg-purple-300",
    tags: ["your-product"],
  },
  {
    title: "Causal inference",
    link: "/solutions/causal-inference",
    color: "bg-yellow-200 hover:bg-yellow-300",
    tags: ["your-product"],
  },
  {
    title: "Demand forecasting",
    link: "/solutions/demand-forecasting",
    color: "bg-blue-300 hover:bg-blue-400",
    tags: ["optimize-operations"],
  },
  {
    title: "Logistics",
    link: "/solutions/logistics-optimization",
    color: "bg-yellow-100 hover:bg-yellow-200",
    tags: ["optimize-operations"],
  },
  {
    title: "Pricing",
    link: "/solutions/pricing-optimization",
    color: "bg-red-200 hover:bg-red-300",
    tags: ["optimize-operations"],
  },
]

const MoreSolutions = ({ currentSolution, tag }) => {
  const [showMore, setShowMore] = React.useState(false)
  const filteredSolutions = cases.filter(
    item => item.title !== currentSolution && item.tags.includes(tag)
  )

  const slides = [...filteredSolutions, ...filteredSolutions]

  const firstbatch = filteredSolutions.slice(0, 3)
  const secondbatch = filteredSolutions.slice(3, 6)

  const Slide = ({ index, style }) => (
    <Link
      style={style}
      aria-label={`Learn about ${slides[index]?.title}`}
      className={cx("transition-all group h-28 tablet:h-48 mobile:pr-6 block")}
      to={slides[index]?.link}
    >
      <div
        className={cx(
          slides[index]?.color,
          "transition-all group shrink-0 h-full rounded-tab px-9 mobile:px-4 tablet:px-10 py-8 flex items-stretch"
        )}
      >
        <div className="flex tablet:flex-col tablet:justify-between items-center tablet:items-start flex-1">
          <SolutionIcon className="w-auto mobile:w-1/4 tablet:w-auto" />
          <h4 className="text-xl mobile:text-[18px] tablet:text-xl font-light ml-9 mobile:ml-4 tablet:ml-0">
            {slides[index]?.title}
          </h4>
        </div>
        <div className="hidden tablet:flex items-end justify-end relative left-[-7px] group-hover:left-0 transition-all">
          <ArrowIcon />
        </div>
      </div>
    </Link>
  )

  return (
    <div className="w-full px-6">
      <h2 className="text-center tablet:text-left container max-w-article text-3xl mb-4 mobile:mb-10">
        More solutions
      </h2>
      <div className="mobile:hidden mb-10">
        <div className="space-y-4 mb-4">
          {firstbatch.map((__item, index) => (
            <Slide key={`slide-first-${index}`} index={index} />
          ))}
        </div>
        {!showMore && secondbatch.length > 0 && (
          <button
            type="button"
            className="w-full h-16 btn-transparent-black"
            onClick={() => setShowMore(true)}
          >
            Load More
          </button>
        )}
        <div className="space-y-4">
          {showMore &&
            secondbatch.length > 0 &&
            secondbatch.map((__item, index) => (
              <Slide key={`slide-second-${index}`} index={index + 3} />
            ))}
        </div>
      </div>
      <div className="hidden mobile:block">
        <SliderControls
          sliderStyle={{
            gridTemplateColumns: `repeat(${slides.length}, calc(100% / 3 + 8px))`,
          }}
          items={filteredSolutions}
          Slide={Slide}
        />
      </div>
    </div>
  )
}

export default MoreSolutions
